<template lang="pug">
  //- Barra de filtros de búsqueda
  .b2b-filters
    b2b-search-bar
      div.block(slot='header')
        ods-tooltip.ods-ml-4(:content='$t("buttons.refresh_tooltip")', placement='bottom')
          ods-button(
            icon='ods-icon-refresh',
            size='medium',
            circle,
            @click="activeRefreshResults")
        ods-button(
          v-if='canCreateComercialRelation',
          size='medium',
          icon='ods-icon-upload'
          @click.native='showAddCommercialRelation')
          | {{ $t('party_detail.channels.buttons.add_commercial_relation') }}

      div(slot='body')
        ods-form.b2b-filters__area(
          :model='filterForm',
          :rules='rules',
          ref='filterForm',
          @submit.native.prevent='')
          ods-form-item.first-input(prop='firstValue')
            //- b2b-select
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='filterForm.firstValue',
              :placeholder='$t("msg_generics.advanced_search")',
              @change='getFirstValue')
              ods-option(
                v-for='option in options',
                :key='option.col',
                :label='$t(option.value)',
                :disabled='option.selected',
                :value='option')
          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              //- Select type
              div(v-if="selected.componente === 'select'")
                ods-form-item.others-input(prop='secondValueSelect')
                  ods-select(v-if="selected.prop != 'id'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='$t("msg_generics.question." + option.type)',
                      :value='option.id')
                  ods-select(v-if="selected.prop == 'id'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :filter-method='filterParties',
                    :placeholder='$t("party_detail.channels.dialog_add_commercial_relation.buyer.write_placeholder")',
                    @change='getSecondValue')
                    ods-option(
                      v-for='(option, index) in comboParties',
                      :key='option.id + "-" + index',
                      :label="option.nif + ' ' + option.name",
                      :value='option.id')
              //- Input type
              div(v-else-if="selected.componente === 'input'" )
                ods-form-item.others-input(prop='secondValue')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model='filterForm.secondValue',
                    @input='getSecondValue')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              ods-button(
                icon='ods-icon-plus',
                size='medium',
                circle,
                @click.native='onSubmit("filterForm")')

    .b2b-filters__container(v-if='listSelectedFiltersCommercialRelation.length > 0')
      transition-group.b2b-filters__group(
        name='ods-fade-in-linear',
        tag='div')
        ods-popover(
          key='icon-delete-filters',
          placement='top-start',
          trigger='hover',
          :content='$t("msg_generics.popover_clean_filters")')
          ods-button.clean-filters(
            slot='reference',
            type='neutral',
            size='small',
            icon='ods-icon-delete'
            @click='handleDeleteAllFilters')

        .b2b-filters__button(
          v-for='(filter, index) in listSelectedFiltersCommercialRelation',
          :key='index + filter')
          b2b-filter-button-commercial-relation(
            :filter='filter',
            @closeTag='resetSelectedOneOption')

    ods-dialog(
      ref='dialogCommercialRelation',
      :title='$t("party_detail.channels.dialog_add_commercial_relation.title")',
      :visible.sync='isShowDialogCommercialRelation',
      :append-to-body='true',
      @close='handleCloseDialog',
      width='30%')
      ods-form(
        ref='formDialogCommercialRelation',
        :model='dialogCommercialRelationForm',
        :rules='rulesAddRelation')
        ods-form-item(
          :label='$t("party_detail.channels.dialog_add_commercial_relation.party")',
          prop='party')
           ods-input(
            :disabled='true',
            v-model='dialogCommercialRelationForm.party')
        ods-form-item(
          v-if='dialogCommercialRelationForm.seller',
          :label='$t("party_detail.channels.dialog_add_commercial_relation.buyer.label")',
          prop='partiesbuyerId')
          ods-select(
            style='width: 100%',
            :no-match-text='$t("msg_generics.no_match")',
            v-model='dialogCommercialRelationForm.partiesbuyerId',
            :placeholder='isBuyerFilterable?$t("party_detail.channels.dialog_add_commercial_relation.buyer.write_placeholder"):$t("party_detail.channels.dialog_add_commercial_relation.buyer.placeholder")',
            filterable,
            :filter-method='filterPartiesBuyer',
            @change='resetComboSeller')
            ods-option(
              v-for='partyBuyer in comboPartiesBuyer',
              :key='partyBuyer.id',
              :label="partyBuyer.nif +' '+partyBuyer.name",
              :value='partyBuyer.id')
        ods-form-item(
          v-if='dialogCommercialRelationForm.buyer',
          :label='$t("party_detail.channels.dialog_add_commercial_relation.seller.label")',
          prop='partiessellerId')
          ods-select(
            style='width: 100%',
            :no-match-text='$t("msg_generics.no_match")',
            v-model='dialogCommercialRelationForm.partiessellerId',
            :placeholder='isSellerFilterable?$t("party_detail.channels.dialog_add_commercial_relation.seller.write_placeholder"):$t("party_detail.channels.dialog_add_commercial_relation.seller.placeholder")',
            filterable,
            :filter-method='filterPartiesSeller',
            @change='resetComboBuyer')
            ods-option(
              v-for='partySeller in comboPartiesSeller',
              :key='partySeller.id',
              :label="partySeller.nif +' '+partySeller.name",
              :value='partySeller.id')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addCommercialRelation("formDialogCommercialRelation")')
          | {{ $t('buttons.btnAdd') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bSearchBar from '@/components/B2bSearchBar'
import B2bFilterButtonCommercialRelation from './B2bFilterButtonCommercialRelation'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filters-commercial-relation',

  props: {
    filterOptions: {
      type: Object,
      required: true
    }
  },

  mixins: [Utils],

  components: {
    B2bSearchBar,
    B2bFilterButtonCommercialRelation
  },

  data () {
    return {
      // Combo empresas
      comboParties: [],
      comboPartiesBuyer: [],
      comboPartiesSeller: [],

      partySelected: null,

      // Relaciones Comerciales
      isShowDialogCommercialRelation: false,
      isSellerFilterable: true,
      isBuyerFilterable: true,
      dialogCommercialRelationForm: {
        // Empresa seleccionada previamnete
        party: null,
        buyer: null,
        seller: null,
        // Relaciones Comerciales
        partiessellerId: null,
        partiesbuyerId: null
      },
      tid: null,

      // Forumlario
      filterForm: {
        firstValue: '',
        secondValue: '',
        secondValueSelect: ''
      },
      selected: {},
      selectedFilters: [],
      options: {},

      // Reglas Validación
      rules: {
        secondValue: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 3, message: this.$t('msg_generics.min_three_letters') }
        ],
        secondValueSelect: [
          {
            required: true,
            message: this.$t('msg_generics.element_selected'),
            trigger: 'change'
          }
        ]
      }
    }
  },

  computed: {
    ...mapGetters([
      'queryCommercialRelation',
      'listSelectedFiltersCommercialRelation',
      'optionsFilterPartyAllCommercialRelation',
      'canCreateComercialRelation'
    ]),
    rulesAddRelation () {
      const checkBuyerSeller = (rule, value, callback) => {
        const buyer = this.dialogCommercialRelationForm.partiessellerId
        const seller = this.dialogCommercialRelationForm.partiesbuyerId
        if (buyer === null && seller === null) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }

      return {
        partiessellerId: [
          { validator: checkBuyerSeller, trigger: 'blur, change' }
        ],
        partiesbuyerId: [
          { validator: checkBuyerSeller, trigger: 'blur, change' }
        ]
      }
    }
  },

  watch: {
    $route (to) {
      this.listSelectedFiltersCommercialRelationState = this.listSelectedFiltersCommercialRelationState // eslint-disable-line
    }
  },

  methods: {
    activeRefreshResults () {
      this.refreshResults()
    },
    ...mapActions([
      'getCommercialRelation',
      'queryCommercialRelationState',
      'listSelectedFiltersCommercialRelationState',
      'getOptionsPartyCommercialRelation',
      'getPartiesService',
      'getPartyService',
      'getProjectPartyService',
      'insertCommercialRelation'
    ]),

    //  Reseteo al cerrar dialogo
    handleCloseDialog () {
      this.$refs.formDialogCommercialRelation.resetFields()
    },

    getFirstValue (data) {
      this.filterForm.secondValue = ''
      this.filterForm.secondValueSelect = ''
      this.$refs.filterForm.clearValidate()
      this.selected = data
    },

    resetComboSeller () {
      this.dialogCommercialRelationForm.partiessellerId = null
      if (this.isSellerFilterable) {
        this.comboPartiesSeller = [] // Limpiamos el combo de empresas vendendoras
      }
    },

    resetComboBuyer () {
      this.dialogCommercialRelationForm.partiesbuyerId = null
      if (this.isBuyerFilterable) {
        this.comboPartiesBuyer = [] // Limpiamos el combo de empresas compradoras
      }
    },

    getSecondValue (data) {
      if (this.selected.componente === 'select' && this.selected.prop !== 'id') {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.value
        this.selected.labelText = this.$t('msg_generics.question.' + option.type)
      } else if (
        this.selected.componente === 'select' &&
        this.selected.prop === 'id'
      ) {
        const option = this.comboParties.find(function (elem) {
          return data === elem.id
        })
        this.selected.query = data
        this.selected.labelText = option.nif + ' ' + option.name
      }
      this.$refs.filterForm.clearValidate()
    },

    getThirdValue (data) {
      console.log('data:', data)
    },

    onSubmit (formName) {
      console.log(formName)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.filter_selected')
          })
          const dataQuery = {
            query: {}
          }
          try {
            console.log('1 Filtro Seleccionado: ', this.selected)
            const column = this.selected.prop
            this.queryCommercialRelation.serviceId = this.$route.params.projectId
            this.queryCommercialRelation.partyId = this.$route.params.partyId

            switch (column) {
              case 'buyer':
                this.queryCommercialRelation.buyer = this.selected.query
                break
              case 'seller':
                this.queryCommercialRelation.seller = this.selected.query
                break
              case 'id':
                this.queryCommercialRelation.id = this.selected.query
                break
              default:
                break
            }

            this.selectedFilters = this.listSelectedFiltersCommercialRelation
            this.selected.selected = true
            this.selectedFilters.push(this.selected)
            await this.listSelectedFiltersCommercialRelationState(
              this.selectedFilters
            )

            this.selected = {}
            this.$refs[formName].resetFields()

            await this.queryCommercialRelationState(
              this.queryCommercialRelation
            )
            dataQuery.query = this.queryCommercialRelation
            await this.getCommercialRelation(dataQuery)
            // this.totalResults = response.data.totalElements

            this.initForm()
          } catch (error) {
            console.log('onSubmit FILTER CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log('error submit!!')
        }
      })
    },

    async handleDeleteAllFilters () {
      console.log(this.selectedFilters)
      this.selectedFilters = []

      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete_all')
      })
      try {
        this.selectedFilters = this.listSelectedFiltersCommercialRelation.map(item => {
          item.labelText = ''
          item.query = ''
          item.selected = false
          return item
        })

        this.queryCommercialRelation.serviceId = this.$route.params.projectId
        this.queryCommercialRelation.partyId = this.$route.params.partyId
        this.queryCommercialRelation.buyer = false
        this.queryCommercialRelation.seller = false
        this.queryCommercialRelation.id = ''

        dataQuery.query = this.queryCommercialRelation
        await this.getCommercialRelation(dataQuery)
        await this.queryCommercialRelationState(this.queryCommercialRelation)
        this.selectedFilters = []
        await this.listSelectedFiltersCommercialRelationState(
          this.selectedFilters
        )

        // Reseteamos la prop selected de los filtros
        this.resetSelectedOptions(this.options)

        this.initForm()
      } catch (error) {
        console.log('getUsers CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async refreshResults () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        dataQuery.query = this.queryCommercialRelation
        await this.getCommercialRelation(dataQuery)
        await this.queryCommercialRelationState(this.queryCommercialRelation)
      } catch (error) {
        console.log('onSubmit FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async getPartiesResults (data) {
      const load = this.$loading({
        lock: true
      })
      try {
        // Buyer y seller
        this.comboParties = await this.getOptionsPartyCommercialRelation({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId,
          tradeNameOrTaxId: data,
          type: 'ALL'
        })
        const party = await this.getPartyService({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId
        })
        this.comboParties.push({
          id: party.id,
          name: party.tradeName,
          nif: party.taxIdentificationNumber
        })
      } catch (error) {
        console.log('getPartiesResults CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Filtro de empresas
    async filterParties (data) {
      try {
      // Si el valor introducido tiene más de 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getPartiesResults, 1000, data)
        }
      } catch (error) {
        console.log('filterPartiesSeller CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async getSellerResults (data) {
      const load = this.$loading({
        lock: true
      })
      try {
        this.comboPartiesSeller = await this.getOptionsPartyCommercialRelation({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId,
          tradeNameOrTaxId: data,
          type: 'SELLER'
        })
      } catch (error) {
        console.log('filterPartiesSeller CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async filterPartiesSeller (data) {
      try {
      // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (this.isSellerFilterable && data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getSellerResults, 1000, data)
        }
      } catch (error) {
        console.log('filterPartiesSeller CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async getBuyerResults (data) {
      const load = this.$loading({
        lock: true
      })
      try {
        this.comboPartiesBuyer = await this.getOptionsPartyCommercialRelation({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId,
          tradeNameOrTaxId: data,
          type: 'BUYER'
        })
      } catch (error) {
        console.log('filterPartiesBuyer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async filterPartiesBuyer (data) {
      try {
      // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (this.isBuyerFilterable && data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getBuyerResults, 1000, data)
        }
      } catch (error) {
        console.log('filterPartiesBuyer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async showAddCommercialRelation () {
      this.isShowDialogCommercialRelation = true
      await this.chargePartiesToNewRelation()
    },

    //* * Inserta una relación comercial */
    addCommercialRelation (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.channels.load.add_commercial_relation')
          })
          try {
            let partyBuyer = null
            let partySeller = null

            // Verificamos si hemos insertado comprador o vendedor
            if (this.dialogCommercialRelationForm.partiessellerId == null) {
              partyBuyer = this.dialogCommercialRelationForm.partiesbuyerId
            } else if (
              this.dialogCommercialRelationForm.partiesbuyerId == null
            ) {
              partySeller = this.dialogCommercialRelationForm.partiessellerId
            }

            const params = {
              serviceId: this.$route.params.projectId,
              partyId: this.$route.params.partyId,
              partyBuyerID: partyBuyer,
              partySellerID: partySeller
            }

            await this.insertCommercialRelation(params)

            const dataQuery = {
              query: {
                serviceId: this.$route.params.projectId,
                partyId: this.$route.params.partyId
              }
            }
            // Refrescamos tabla relaciones comerciales
            await this.getCommercialRelation(dataQuery)

            this.$notify({
              title: this.$t('party_detail.channels.notify.add_commercial_relation'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogCommercialRelation = false
          }
        }
      })
    },

    // Metodo lanzado al capturar el evento de closeTag
    async resetSelectedOneOption (data) {
      this.resetOneOption(this.options, data.filter)
      await this.listSelectedFiltersCommercialRelationState(data.listAfterRemove)
      this.initForm()
    },

    async chargePartiesToNewRelation () {
      const party = await this.getPartyService({
        serviceId: this.$route.params.projectId,
        partyId: this.$route.params.partyId
      })
      if (this.$route.params.partyId && this.$route.params.projectId) {
        const response = await this.getProjectPartyService({
          serviceId: this.$route.params.projectId,
          partyId: this.$route.params.partyId
        })
        // Agregamos empresa selecionada al combo de empresas y al dialogo
        this.partySelected = party
        this.dialogCommercialRelationForm.party = party.taxIdentificationNumber + '  ' + party.tradeName
        this.dialogCommercialRelationForm.buyer = response.buyer
        this.dialogCommercialRelationForm.seller = response.seller
      }

      // Buyer
      // if (this.dialogCommercialRelationForm.partiessellerId == null) {
      if (this.dialogCommercialRelationForm.seller) {
        const compradores = await this.getOptionsPartyCommercialRelation(
          {
            serviceId: this.$route.params.projectId,
            partyId: this.$route.params.partyId,
            type: 'BUYER',
            page: 0,
            size: 55
          }
        )
        if (compradores.length < 51) {
          this.comboPartiesBuyer = compradores
          this.isBuyerFilterable = false
        }
      }

      // Seller
      if (this.dialogCommercialRelationForm.buyer) {
        const vendedores = await this.getOptionsPartyCommercialRelation(
          {
            serviceId: this.$route.params.projectId,
            partyId: this.$route.params.partyId,
            type: 'SELLER',
            page: 0,
            size: 55
          }
        )
        if (vendedores.length < 51) {
          this.comboPartiesSeller = vendedores
          this.isSellerFilterable = false
        }
      }
    },

    initForm () {
      if (!this.options.nombre.selected) {
        this.filterForm.firstValue = this.options.nombre
        this.selected = this.filterForm.firstValue
      } else {
        this.filterForm.firstValue = ''
        this.selected = this.filterForm.firstValue
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 409:
        case 404:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    // Creamos una copia del json que contiene los datos de los filtros y trabajamos con la copia
    this.options = JSON.parse(JSON.stringify(this.filterOptions))

    // Ponemos el estado de selected a true si ya estaba seleccionado el filtro
    this.checkListFilterSelected(this.options, this.listSelectedFiltersCommercialRelation)

    this.initForm()
    try {
      await this.queryCommercialRelationState(this.queryCommercialRelation)
    } catch (error) {
      this.getNotificationErrorMessage(error)
    }
  },

  async updated () {
    this.options.nombre.options = this.optionsFilterPartyAllCommercialRelation
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ods-input__prefix {
  height: 72px !important;
}
::v-deep .ods-input__suffix {
  height: 72px !important;
}
.b2b-filters {
  ::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
  }
::v-deep .ods-icon-close, body .ods-icon-close {

    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -4px;
    color: var(--color-bg-interactive);
}
::v-deep .ods-tag {

    display: inline-block;
    height: 24px;
    line-height: 14px;
    background-color: white;
    padding-top: 5px;
    font-size: 9px;
    color: var(--color-bg-interactive);
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "微软雅黑", Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 1px solid;
}
::v-deep .ods-select .ods-tag {
    display: inline-flex;
    margin: 2px 0 -52px 6px;
    .ods-tag__content {
      .ods-select__tags-text {
        text-transform: none;
      }
      max-width: 100%;
    min-width: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: calc(100% - 8px);
    display: inline-block;
    vertical-align: bottom;
    }
  }
  .b2b-filters__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
  }
  // background-color: var(--color-bg-primary);
  // border-top: .1rem solid $grey-2;
  // box-shadow: 0 0.2rem 0.8rem 0 rgba(0, 0, 0, 0.08);

  .ods-button {
    display: inline;
    margin-right: rem(24);
  }

  ::v-deep &__area {
    display: flex;

    .ods-form-item {
      margin-bottom: 0;
      &__content {
        line-height: inherit;
      }
      &__error {
        top: rem(55);
      }
      input {
        max-width: rem(200);
      }
      select {
        max-width: rem(200);
      }
    }

    .first-input {
      margin-right: rem(32);
    }

    // Para los input que no sean datepicker,
    // colocar un margen igual a como si tuviese el botón del datepicker
    .others-input {
      margin-right: rem(16);
    }

    .ods-range-separator {
      padding: 0 rem(8);
    }
  }

  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;

    .clean-filters {
      color: var(--color-status-info-400);
      .ods-icon-delete {
        margin-left: 0px;
      }
    }
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }
}
</style>
